/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import { MsalProvider } from '@azure/msal-react'
import { LogLevel, PublicClientApplication } from '@azure/msal-browser'
import {
  isMsAuthEnabled,
  msClientId as clientId,
  ocidRedirectUri as redirectUri,
  msAuthAuthority as authority,
} from './utils'

/**
 * setup configuration
 */

const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            break
          case LogLevel.Info:
            console.info(message)
            break
          case LogLevel.Verbose:
            console.debug(message)
            break
          case LogLevel.Warning:
            console.warn(message)
            break
          default:
            console.log(message)
        }
      },
    },
    windowHashTimeout: 60000,
    iframeHashTimeout: 60000,
  },
}

const MsAuthSupport = ({ children }) => {
  if (isMsAuthEnabled) {
    return (
      <MsalProvider instance={new PublicClientApplication(msalConfig)}>
        {children}
      </MsalProvider>
    )
  }
  return children
}

export default MsAuthSupport
